<template>
  <div class="kv-ve-width-slider">
    <div v-if="showHeader" class="kv-ve-width-slider__label-row">
      <label class="kv-ve-width-slider__label">{{ label }}</label>
      <div class="kv-ve-width-slider__value">
        <template v-if="editableValue">
          <input
            class="kv-ve-width-slider__value-input"
            type="number"
            :min="min"
            :max="max"
            :step="step"
            :value="safeValue"
            @input="onNumberInput"
          />
          <span class="kv-ve-width-slider__unit">{{ unit }}</span>
        </template>
        <template v-else>
          {{ displayValue }}
        </template>
      </div>
    </div>

    <div class="kv-ve-width-slider__controls">
      <input
        class="kv-ve-width-slider__range"
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="safeValue"
        @input="onInput"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "VeWidthSlider",
  model: { prop: "value", event: "input" },
  props: {
    label: { type: String, required: true },
    value: { type: Number, default: 100 },
    min: { type: Number, default: 10 },
    max: { type: Number, default: 100 },
    step: { type: Number, default: 1 },
    unit: { type: String, default: "%" },
    showHeader: { type: Boolean, default: true },
    editableValue: { type: Boolean, default: false },
  },
  computed: {
    safeValue() {
      const n = Number(this.value);
      if (!Number.isFinite(n)) return this.max;
      return Math.min(this.max, Math.max(this.min, Math.round(n)));
    },
    displayValue() {
      return `${this.safeValue}${this.unit}`;
    },
  },
  methods: {
    onInput(e) {
      const n = Number(e?.target?.value);
      const next = Number.isFinite(n) ? n : this.safeValue;
      this.$emit("input", next);
    },
    onNumberInput(e) {
      const n = Number(e?.target?.value);
      const nextRaw = Number.isFinite(n) ? n : this.safeValue;
      const next = Math.min(this.max, Math.max(this.min, Math.round(nextRaw)));
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped lang="less">
.kv-ve-width-slider__label-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}
.kv-ve-width-slider__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #344054;
}
.kv-ve-width-slider .kv.kv-ve-width-slider__value {
  font-size: 12px;
  font-weight: 400;
  color: #101828;
  font-variant-numeric: tabular-nums;
}
.kv-ve-width-slider__value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.kv-ve-width-slider__value-input {
  width: 88px;
  height: 30px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 10px;
  font-size: 12px;
  box-shadow: none;
  font-variant-numeric: tabular-nums;
}
.kv-ve-width-slider__value-input:focus {
  outline: none;
  border-color: rgba(42, 170, 76, 0.65);
  box-shadow: 0 0 0 4px rgba(42, 170, 76, 0.14);
}
.kv-ve-width-slider__unit {
  color: #667085;
}
.kv-ve-width-slider__controls {
  display: flex;
  align-items: center;
}
.kv-ve-width-slider__range {
  width: 100%;
}
</style>


